export default "__VITE_ASSET__Dll57oTE__"